<template>
    <svg width="20px" height="22.000061px" viewBox="0 0 20 22.000061" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
        <g id="iconAdjustment" transform="translate(-6 -5)">
            <path d="M26 6C26 5.44772 25.5523 5 25 5L7 5C6.44772 5 6 5.44772 6 6L6 9L14 18L14 26C14 26.2164 14.0702 26.4269 14.2 26.6C14.5314 27.0418 15.1582 27.1314 15.6 26.8L17.6 25.3C17.8518 25.1111 18 24.8148 18 24.5L18 18L26 9L26 6ZM11.3424 12L8 8.24L8 7L24 7L24 8.239L20.6571 12L11.3424 12Z" id="Combined-Shape" fill-rule="evenodd" stroke="none" />
        </g>
    </svg>
</template>
